import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import HeaderBanner from '../../images/event/cpd-header.png'
import standingbanner from '../../images/backdrops/standing-banner.png'
import Amplitude from 'src/utils/amplitudeHelper'
import { SIZES } from 'src/styles/theme'

const StyledModal = styled(Modal)`
  .modal-content {
    width: 100%;
    margin: 0 auto;
    border: none;
    border-radius: 28px;
    background: #fff;
  }
  #banner {
    display: block;
    margin-top: -3.5em;
    margin-left: auto;
    margin-right: 0;
    width: 100%;
  }
  .modal-header {
    border: none;
    padding: 0.5rem 2rem;
    .close {
        color: #414141;
        opacity: 1;
        padding: 16px;
      margin-right: 0;
      font-size: 40px;
      font-weight: 400;
      text-shadow: none;
    }
}
  .modal-body {
    width: 90%;
    margin: 0 auto;
    padding-top: 0;
    // padding-left: 30px;
    // padding-right: 30px;
}

  #content-container {
      margin: 16px 0;
    min-height: 350px;
    position: relative;
    color: #022136;
    h3 {
        text-align: center;
        font-weight: 600;
        padding-bottom: 3rem;
    }
    h5 {
      font-weight: 700;
      padding-bottom: 1rem;
      padding-top: 1rem;
    }
    li {
        font-style: italic;
    }
    img {
      display: block;
      margin: 0 auto;
      width: 60%;
    }
  }
  ${SIZES.mobile} {
    .modal-content {
      width: 100%;
      border-radius: 0px;
    }
    #banner {
      display: block;
      margin: 0;
      width: 100%;
    }
    .modal-header {
      padding: 0;
      .close {
        position: absolute;
        right: 15px;
        top: 15px;
      }
    }
    #content-container {
      img {
        width: 90%;
      }
    }
  }
`

export default function FAQModal({ showModal, hideModal }) {
  return (
    <StyledModal scrollable={true} backdrop={false} show={showModal} onHide={hideModal} aria-labelledby="game-modal" size="lg" centered>
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body>
        <section id="content-container">
          <h3>Vimeo Live – Stream Viewing Requirements</h3>
          <h5>Supported browsers — playback</h5>
          <p>We support playback in browsers that can decode H.264 videos in an HTML5 player. Due to rising security vulnerabilities, Vimeo no longer supports Flash. If you’re using an older browser, system, or website, you’ll need to upgrade to continue watching Vimeo videos.</p>
          <ul>
              <p>Here is a list of our supported browsers/versions:</p>
              <li>Chrome 30+ (has automatic updates)</li>
              <li>Firefox 27+ (has automatic updates)*</li>
              <li>Internet Explorer 11*</li>
              <li>Microsoft Edge</li>
              <li>Safari 9+</li>
          </ul>
          <p>*H.264 video (required for viewing Vimeo videos) is only supported in Firefox for Windows 7 and later. Firefox versions on Windows XP are no longer supported for playback.</p>
          <p>*Older versions of Internet Explorer (IE 10, 9, 8, etc) that lack support for the TLS 1.2 protocol and HTML5 cannot be used to play Vimeo videos. As of January 12, 2016, Microsoft has stopped releasing updates to older versions of IE. (Microsoft’s official statement on IE support can be found here)</p>
          <h5>Supported operating systems — playback</h5>
          <p>The Vimeo player operates in a wide range of operating systems, but we can only guarantee full functionality on systems that are still being supported by their proprietors.</p>
          <p>Microsoft has ended support for Windows XP and Windows Vista.</p>
          <p>The earliest version of MacOS still receiving extended support from Apple is Sierra (v. 10.12.6), and support for it is rumored to end in September 2019. Earlier versions of MacOS (El Capitan, Yosemite, Mavericks, etc) are not supported.</p>
          <p>While we still love to hear about Vimeo bugs affecting older systems, we cannot always guarantee they’ll be prioritized or solved.</p>
          <h5>Mobile/Tablets</h5>
          <ul>
              <li>Android (Lollipop) version 5.0+</li>
              <li>iOS version 9.3.5+</li>
          </ul>
          <p>⚠️ Blackberry and Windows phone users: You may still able to view Vimeo videos on devices that support HTML5; however, we do not test out our player in these environments and thus cannot guarantee support.</p>
          <p>Supported browsers — vimeo.com site</p>
          <p>For vimeo.com access and features, we currently support the latest version of the following browsers (mobile/desktop):</p>
          <ul>
              <li>Chrome (has automatic updates)</li>
              <li>Firefox (has automatic updates)</li>
              <li>Safari</li>
              <li>Edge</li>
              <li>Internet Explorer 11</li>
          </ul>
          <p>If you see a banner on vimeo.com asking you to upgrade your browser, you can check for the latest browser versions here.</p>
          <h5>Live events</h5>
          <p>Similar to uploaded videos, playback for live events is supported on any setup that supports H.264 videos, HTML5, and Media Source (specifically required for our adaptive streaming system). Please see our supported systems for playback above, with the following exceptions:</p>
          <ul>
              <li>Internet Explorer 11 on Windows 7 and earlier is not supported for Vimeo Live</li>
              <li>The Samsung Internet browser (all versions) is also not supported for Vimeo Live. We recommend installing Chrome instead</li>
          </ul>
          <h5>Internet Connection Requirements (playback)</h5>
          <p>We require minimum stable download speeds of 500 kbps or faster in order to view our lowest quality, SD 240p. Since bandwidth tends to fluctuate for a number of unforeseen variables, we always recommend you use a dedicated Internet line of 5 Mbps or faster to stream and download high quality videos on the Internet. For optimal performance, a hardwired connection via Ethernet is best, but if you prefer to use WiFi, be sure that your router is configured correctly and that your network is not being shared with other devices (this can limit the starting speeds you pay your ISP for).</p>
          <p>Not sure what speeds your device is receiving? Visit https://testmy.net/download (on mobile or desktop) for an estimate. We recommend performing this test a few times since bandwidth can change.</p>
          <p>For more in-depth information about bandwidth and troubleshooting, please visit this article on playback quality and buffering issues.</p>
        </section>
      </Modal.Body>
    </StyledModal>
  )
}